import { constants } from "@reactivated/constants";

// Checkout Form Steps
export enum Step {
    LOGIN = 1,
    SHIPPING_ADDRESS = 2,
    SHIPPING_METHOD = 3,
    BILLING_ADDRESS = 4,
    PAYMENT_METHODS = 5,
    PLACING_ORDER = 6,
}

type StepIndexCheckoutFormNameMapType = {
    [V in (typeof Step)[keyof typeof Step]]: `checkout_${string}`;
};

export const StepIndexCheckoutFormNameMap: StepIndexCheckoutFormNameMapType = {
    [Step.LOGIN]: "checkout_login",
    [Step.SHIPPING_ADDRESS]: "checkout_shipping",
    [Step.SHIPPING_METHOD]: "checkout_delivery_options",
    [Step.BILLING_ADDRESS]: "checkout_billing",
    [Step.PAYMENT_METHODS]: "checkout_payment",
    [Step.PLACING_ORDER]: "checkout_placing_order",
};

export enum ConfigureGiftStatus {
    LOADING = "LOADING",
    LOADED = "LOADED",
    ADDING_TO_BASKET = "ADDING_TO_BASKET",
    SELECTION_ERROR = "SELECTION_ERROR",
    COMPLETE = "COMPLETE",
}

export enum PredictedDeliveryDateStatus {
    INITIAL = "initial",
    LOADING = "loading",
    LOADED = "loaded",
    ERROR = "error",
}

export const enum PredictedDeliveryDateDisplayType {
    DISABLED = "disabled",
    SHOW_CONSERVATIVE = "show-conservative",
    SHOW_AGGRESSIVE = "show-aggressive",
}

export enum PredictedDeliveryDateStyle {
    ONE_LINE = "one-line",
    TWO_LINE = "two-line",
}

export const enum PreferredDeliveryDateDisplayType {
    DISABLED = "disabled",
    SHOW_CONSERVATIVE = "show-conservative",
    SHOW_AGGRESSIVE = "show-aggressive",
}

// Cybersource Credit Card Types
export const CARD_TYPE_VISA = "001";
export const CARD_TYPE_MASTERCARD = "002";
export const CARD_TYPE_AMEX = "003";
export const CARD_TYPE_DISCOVER = "004";

export const getCardNameFromType = (cardType: string): string | null => {
    switch (cardType) {
        case CARD_TYPE_AMEX:
            // TODO(i18n): Wrap in t tagged template: t`American Express`
            return "American Express";
        case CARD_TYPE_DISCOVER:
            // TODO(i18n): Wrap in t tagged template: t`Discover Card`
            return "Discover Card";
        case CARD_TYPE_MASTERCARD:
            // TODO(i18n): Wrap in t tagged template: t`MasterCard`
            return "MasterCard";
        case CARD_TYPE_VISA:
            // TODO(i18n): Wrap in t tagged template: t`Visa`
            return "Visa";
        default:
            return null;
    }
};

// Misc
export const PRIMARY_PAYMENT_METHOD_KEY = "1-primary";
export const SECONDARY_PAYMENT_METHOD_KEY = "2-secondary";
export const DEFAULT_PHONE_NUMBER = "+1";
export const DEFAULT_COUNTRY = "/api/countries/US/";

export const LIST_FAVORITES = "favorites";
export const LIST_PREVIOUSLY_IN_BASKET = "previously-in-basket";

export const RECYCLING_FEE_NAME = "STATE EXCISE TAX-MATTRESS";

export const SHIPPING_METHOD_NAMES: { [c: string]: string } = {
    // TODO(i18n): Wrap in t tagged template: t`White Glove Delivery`
    "TMS": "White Glove Delivery",
    // TODO(i18n): Wrap in t tagged template: t`UPS Ground Shipping`
    "UPS GROUND": "UPS Ground Shipping",
    // TODO(i18n): Wrap in t tagged template: t`UPS 2nd Day Air`
    "UPS 2 DAY": "UPS 2nd Day Air",
    // TODO(i18n): Wrap in t tagged template: t`UPS Next Day Air`
    "UPS NEXT DAY": "UPS Next Day Air",
};

// BasketLine Variants
export const enum BasketLineVariant {
    MINIMAL,
    MINIMAL_ENHANCED,
    FULL,
}

export const VIRTUAL_BASKET_LINE_BENEFIT_TYPE =
    constants.VIRTUAL_BASKET_LINE_BENEFIT_TYPE;
